import React, { useContext } from 'react';
import { Button, Typography, Popover, popoverClasses } from '@mui/material';
import { NotebookFeedbackCtx, DatasetSelectionCtx, UserCtx, } from '../../App/ApplicationContext';
import { DialogWrapper } from '../../GenericUI/DialogWrapper';
import { SharedUI } from './SharedUI';
import { NotebookResumeAlert, StageSizeAlert, WorkflowProgressAlert, } from '../../GenericUI/Alerts';
import { COMPLETE } from '../../../types/dataTypes';
import { OPERATION, } from '../../../types/searchTypes';
import { handleCreateNotebook, handleResumeNotebook, } from '../../../utils/Swirrl/createNotebook';
import { STAGELIMIT } from '../../App/ApplicationConfig';
const classes = {
    buttonGroup: {
        display: 'flex',
        justifyContent: 'end',
    },
    generateButton: {
        margin: '10px auto 0px auto',
        display: 'flex',
        minWidth: '150px',
    },
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: '8px',
        backgroundColor: 'red',
        color: 'white',
    },
};
export const ResumeNotebook = ({ completed, fileListObject, myQueryLimit, notebookSize, stageSize, operation, // Use this to determine the message.
subsettingParameters, subsettingMode, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { notebookProperties, setNotebookProperties } = useContext(NotebookFeedbackCtx);
    const { datasetCollection } = useContext(DatasetSelectionCtx);
    const { user, setUser } = useContext(UserCtx);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (React.createElement(DialogWrapper, { title: 'Resume Notebook', size: 'md', buttonTitle: null, buttonCallback: () => { }, buttonDisabled: null, clearOnClose: false },
        React.createElement(React.Fragment, null,
            React.createElement(SharedUI, Object.assign({}, {
                completed,
                fileListObject,
                myQueryLimit,
            })),
            React.createElement(NotebookResumeAlert, { url: (user === null || user === void 0 ? void 0 : user.notebookURL) || '', notebookSize: notebookSize }),
            React.createElement(WorkflowProgressAlert, Object.assign({}, notebookSize)),
            React.createElement(StageSizeAlert, { stageSize: stageSize, operation: operation }),
            React.createElement("div", { style: classes.buttonGroup },
                React.createElement(Button, { "aria-owns": open ? 'mouse-over-popover' : undefined, "aria-haspopup": 'true', onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose, sx: classes.generateButton, color: 'primary', variant: 'outlined', disabled: completed !== COMPLETE ||
                        (operation === OPERATION.DOWNLOAD && stageSize > STAGELIMIT), onClick: () => {
                        if (operation === OPERATION.SUBSETTING) {
                            handleCreateNotebook(setNotebookProperties, notebookProperties, OPERATION.SUBSETTING, fileListObject, user, setUser, datasetCollection, subsettingParameters, subsettingMode);
                        }
                        else {
                            handleCreateNotebook(setNotebookProperties, notebookProperties, OPERATION.DOWNLOAD, fileListObject, user, setUser);
                        }
                    } }, "New Notebook"),
                React.createElement(Popover, { id: 'mouse-over-popover', sx: Object.assign(Object.assign({}, classes.popover), { [`& .${popoverClasses.paper}`]: classes.paper }), open: open, anchorEl: anchorEl, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    }, onClose: handlePopoverClose, disableRestoreFocus: true },
                    React.createElement(Typography, null, "This will delete your old notebook.")),
                React.createElement(Button, { sx: classes.generateButton, color: 'primary', variant: 'contained', disabled: completed !== COMPLETE ||
                        (operation === OPERATION.DOWNLOAD && stageSize > STAGELIMIT), onClick: () => {
                        if (operation === OPERATION.SUBSETTING) {
                            handleResumeNotebook(setNotebookProperties, notebookProperties, OPERATION.SUBSETTING, fileListObject, user, datasetCollection, subsettingParameters, subsettingMode);
                        }
                        else {
                            handleResumeNotebook(setNotebookProperties, notebookProperties, OPERATION.DOWNLOAD, fileListObject, user);
                        }
                    } }, "Resume Notebook")))));
};
export const NewNotebook = ({ completed, fileListObject, myQueryLimit, operation, subsettingParameters, subsettingMode, stageSize, }) => {
    const { notebookProperties, setNotebookProperties } = useContext(NotebookFeedbackCtx);
    const { datasetCollection } = useContext(DatasetSelectionCtx);
    const { user, setUser } = useContext(UserCtx);
    return (React.createElement(DialogWrapper, { title: 'New Notebook', buttonTitle: 'Generate Notebook', buttonDisabled: completed !== COMPLETE ||
            (operation === OPERATION.DOWNLOAD && stageSize > STAGELIMIT), buttonCallback: operation === OPERATION.SUBSETTING
            ? () => {
                handleCreateNotebook(setNotebookProperties, notebookProperties, OPERATION.SUBSETTING, fileListObject, user, setUser, datasetCollection, subsettingParameters, subsettingMode);
            }
            : () => {
                handleCreateNotebook(setNotebookProperties, notebookProperties, OPERATION.DOWNLOAD, fileListObject, user, setUser);
            }, size: false, clearOnClose: false },
        React.createElement(React.Fragment, null,
            React.createElement(SharedUI, Object.assign({}, {
                completed,
                fileListObject,
                myQueryLimit,
            })),
            React.createElement(StageSizeAlert, { stageSize: stageSize, operation: operation }))));
};
